module.exports = __webpack_public_path__ + "static/media/50.d4a4bd69.png";